module.exports = {
  "defaultCurrency": "CHF",
  "currencies": []
}